import { Post } from "@forcode/domain";
import css from "../PostCard.module.css";

import { Link, Typography } from "../../../atom";
import { PostCardAuthor } from "./PostCardAuthor";
import { PostCardMeta } from "./PostCardMeta";
import { BASE_CLASS } from "../PostCard";

interface PostCardContentProps {
  post: Post;
}

export const PostCardContent = ({ post }: PostCardContentProps) => {
  const { title, excerpt, category, meta, author, urlSlug } = post;

  return (
    <>
      <PostCardMeta {...{ category, createdAt: meta.createdAt }} />
      <Typography as="h2" className={css[`${BASE_CLASS}-title`]}>
        <Link href={urlSlug}>{title}</Link>
      </Typography>
      {excerpt && (
        <Typography as="p">
          <Link href={urlSlug}>{excerpt}</Link>
        </Typography>
      )}
      <PostCardAuthor {...{ author }} />
    </>
  );
};
